import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { LinearProgress as LinearProgress$1 } from '@mui/material';

const LinearProgress = (_a) => {
    var { progress, width = '56px', height = '8px', color = 'success' } = _a, props = __rest(_a, ["progress", "width", "height", "color"]);
    return (jsx("div", { style: { width: width, height: height }, children: jsx(LinearProgress$1, Object.assign({ variant: "determinate", value: progress, color: color }, props)) }));
};

export { LinearProgress as L };
//# sourceMappingURL=LinearProgress-49f92eed.js.map
